export const ENROLLMENT_FEE = 350;
export const ONE_TIME_PAYMENT = 54111;
export const POST_PLACEMENT_FEE = 100000;

export const OFFICE_CONTACT_NUMBER = "+91 7977150541";
export const INSTALLMENT_FIRST_PAYMENT = 10000;